export function despliegueMenu(e){
  e.preventDefault();
  var filtersContainer = document.getElementsByClassName('filters-container')[0];
  if(!filtersContainer.classList.contains('visible')){
    filtersContainer.classList.add('visible');

    if(filtersContainer.classList.contains('invisible')){
      filtersContainer.classList.remove('invisible');
    }

  }else{
    filtersContainer.classList.remove('visible');

    if(!filtersContainer.classList.contains('invisible')){
      filtersContainer.classList.add('invisible');
    }

  }
}

